var _path, _path2, _line, _line2, _path3, _path4, _polyline, _polyline2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.775,12.976c.13.63.198,1.285.198,1.957,0,4.964-3.732,8.987-8.335,8.987s-8.335-4.024-8.335-8.987c0-2.859,1.238-5.406,3.168-7.052"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.768,38.735v-5.431c0-1.856-1.09-3.54-2.784-4.299l-8.473-3.8-5.511,7.515-5.511-7.515-8.473,3.8c-1.694.76-2.784,2.443-2.784,4.299v5.431"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.667,
    y1: 38.696,
    x2: 10.667,
    y2: 37.332
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 31.305,
    y1: 38.696,
    x2: 31.305,
    y2: 37.332
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.992,7.611l.467.255c4.187,2.286,8.672,3.978,13.326,5.027l.187.042.678-3.569c.201-1.056-.274-2.126-1.191-2.687h0c-2.97-1.816-6.298-2.969-9.755-3.38l-.128-.015c-1.228-.146-2.387.598-2.765,1.775l-.82,2.552Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m29.387,10.145s-3.668-1.51-7.043-2.642"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "11.985 26.776 10.667 30.87 14.992 29.807 21 38.206"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "30.015 26.776 31.333 30.87 27.008 29.807 21 38.206"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorCheckin);
export default __webpack_public_path__ + "static/media/indoor-checkin.19cf388e0d275d6c21354bae57464c41.svg";
export { ForwardRef as ReactComponent };